const DECISIONS_AND_INTERPRETATIONS = 'DECISIONS_AND_INTERPRETATIONS';

const DEFAULT_REQUEST_TAG_CODES_BY_CATEGORY_TYPE = {
    PRECEDENT: ['cases'],
    DECISIONS_AND_INTERPRETATIONS: ['행정심판례', '결정례', '유권해석'],
} as const;

const normalizeCategoryType = (categoryType?: string): string => {
    if (categoryType === 'DECISION') {
        return DECISIONS_AND_INTERPRETATIONS;
    }

    return categoryType || '';
};

export const getDefaultRequestTagCodesForCategoryType = (categoryType?: string): string[] => {
    const normalizedCategoryType = normalizeCategoryType(categoryType);

    if (normalizedCategoryType === 'PRECEDENT') {
        return [...DEFAULT_REQUEST_TAG_CODES_BY_CATEGORY_TYPE.PRECEDENT];
    }

    if (normalizedCategoryType === DECISIONS_AND_INTERPRETATIONS) {
        return [...DEFAULT_REQUEST_TAG_CODES_BY_CATEGORY_TYPE.DECISIONS_AND_INTERPRETATIONS];
    }

    return [];
};
